<template>
  <div v-if="showModuloForm === false">
    <MarketingModules></MarketingModules>
  </div>
  <div class="page" v-else-if="showModuloForm === true">
    <Panel lineColor="var(--primary-color)">
      <template v-slot:options>
        <FormButtonGroup align="end" spaced>
          <FormButton text="Novo usuário" type="primario" @click="onNew" />
        </FormButtonGroup>
      </template>
      <DataTable
        :headers="headers"
        :endpoint="endpoint"
        :filters="filters"
        :additionalData="datatableAdditionalData"
        noHideFilters
        sortBy="nome"
        :sortDesc="false"
        ref="datatable"
        search
        @click="onRowClick"
      >
        <template v-slot:ativo="{ col }">
          <Chip v-if="col" color="green" text="Sim" :small="true" />
          <Chip v-else color="cyan" text="Não" :small="true" />
        </template>
        <template v-slot:tipo_vendedor="{ col }">
          {{ formatTipoVendedor(col) }}
        </template>
      </DataTable>
    </Panel>
    <transition name="slide-popup" mode="out-in">
      <router-view class="view" @close="onClose"></router-view>
    </transition>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import Panel from "@/components/Panel";
import Chip from "@/components/Chip";
import FormButton from "@/components/form/FormButton";
import FormButtonGroup from "@/components/form/FormButtonGroup";
import MarketingModules from "@/components/MarketingModules";
import { mapGetters } from "vuex";
import { ModulesEnum } from "@/store/actions/modulesEnum";

const TIPO_VENDEDOR_LABELS = {
  INTERNO: "Interno",
  EXTERNO: "Externo"
};

const TIPO_VENDEDOR_FILTER_OPTIONS = [
  { text: "Interno", value: "INTERNO" },
  { text: "Externo", value: "EXTERNO" },
  { text: "Não é vendedor", value: "__SEM_TIPO__" }
];

export default {
  name: "UsuarioTable",
  components: {
    DataTable,
    Panel,
    Chip,
    FormButton,
    FormButtonGroup,
    MarketingModules
  },
  data: () => ({
    headers: [
      { text: "Nome", value: "nome" },
      { text: "E-mail", value: "nomeusuario" },
      { text: "Empresa", value: "parceiro" },
      { text: "Tipo de vendedor", value: "tipo_vendedor", align: "center" },
      { text: "Perfil", value: "perfil_nome", align: "center" },
      { text: "Ativo", value: "ativo", align: "center" },
      { text: "Id usuário ERP", value: "id_usuario_erp", align: "center" }
    ],
    filters: [
      {
        label: "Tipo de vendedor",
        query: "tipo_vendedor",
        type: "autocomplete",
        clearable: true,
        options: TIPO_VENDEDOR_FILTER_OPTIONS
      }
    ],
    modulosForm: [
      ModulesEnum.PORTFOLIO_WEB,
      ModulesEnum.ORCAMENTO_WEB,
      ModulesEnum.ORCAMENTO_APP,
      ModulesEnum.VENDAMAIS_WEB,
      ModulesEnum.VENDAMAIS_APP,
      ModulesEnum.WEB_COMMERCE,
      ModulesEnum.COMMERCE_APP
    ]
  }),
  computed: {
    ...mapGetters([
      "getEmpresaId",
      "getFornecedorId",
      "getUsuarioId",
      "moduloFornecedorAtivo"
    ]),
    endpoint() {
      return `/api/v4/usuario/${this.getEmpresaId}/datatable`;
    },
    datatableAdditionalData() {
      if (!this.getFornecedorId) {
        return {};
      }
      return { idfornecedor: this.getFornecedorId };
    },
    showModuloForm() {
      return this.moduloFornecedorAtivo(this.modulosForm);
    }
  },
  methods: {
    formatTipoVendedor(tipo) {
      if (!tipo) {
        return "";
      }
      const normalizado = String(tipo)
        .trim()
        .toUpperCase();
      return TIPO_VENDEDOR_LABELS[normalizado] || tipo;
    },
    onNew() {
      this.$router.push({ name: "UsuarioForm" });
    },
    onMyUser() {
      this.$router.push("/fornecedor/configuracoes/usuarios/meu-usuario");
    },
    onRowClick(row) {
      if (!row || !row.idusuario) {
        return;
      }
      if (row.idusuario === this.getUsuarioId) {
        return this.onMyUser();
      }
      this.$router.push({
        name: "UsuarioEdit",
        params: { idusuario: row.idusuario }
      });
    },
    onClose() {
      if (this.$refs.datatable) {
        this.$refs.datatable.reload();
      }
    }
  }
};
</script>
